import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateSavedDocumentCommentArgs,
  BackendSavedDocumentComment,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateSavedDocumentComment($commentId: ID!, $text: String!) {
    updateSavedDocumentComment(commentId: $commentId, text: $text) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateSavedDocumentCommentArgs;
type Result = Pick<BackendSavedDocumentComment, 'id'>;

export const updateSavedDocumentComment = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
